/**
 * TIME Inside — Agenti AI (Servizi)
 */

export const AGENTS = [
  {
    slug: "custos",
    name: "Custos",
    role: "Guardiano del Tempo",
    image: "/images/custos.png",
    tagline:
      "Presidia, protegge e mantiene l'integrità del sistema TIME.",
    chatUrl:
      "https://chatgpt.com/g/g-6a214bfca8b48191be122ebbab823141-custos",
  },
  {
    slug: "lavia",
    name: "Lavìa",
    role: "Guida del Tempo",
    image: "/images/lavia.png",
    tagline:
      "Accompagna, orienta e apre nuove direzioni all'interno dell'ecosistema.",
    chatUrl:
      "https://chatgpt.com/g/g-6a256a529160819193929e5c44682e59-lavia",
  },
  {
    slug: "testis",
    name: "Testis",
    role: "Il Testimone del Tempo",
    image: "/images/testis.png",
    tagline:
      "Ti aiuterà a osservare, comprendere e testimoniare il rapporto che hai costruito con il tuo Tempo.",
    chatUrl:
      "https://chatgpt.com/g/g-6a534140ee588191822c430425e1f60a-testis",
  },
];

export function findAgent(slug) {
  return AGENTS.find((a) => a.slug === slug) || null;
}
